import { queryOptions, useQuery } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PartFile } from "@vendata/power-up-spec";

// Sample query for reference - get part files
interface GetPartFilesQueryOptions {
  partId: Ref<string>;
}

export const getPartFilesQuery = (options: GetPartFilesQueryOptions) => {
  return queryOptions({
    queryKey: ["parts", "files", options.partId],
    queryFn: async (): Promise<PartFile[]> => {
      return handleClientMethod(
        getClient().GET("/parts/{id}/files", {
          params: {
            path: {
              id: options.partId.value,
            },
          },
        }),
      );
    },
  });
};

export const useGetPartFiles = (options: GetPartFilesQueryOptions) => {
  return useQuery(getPartFilesQuery(options));
};
